import Vue from 'vue'
import VueI18n from 'vue-i18n'
Vue.use(VueI18n)

// Create VueI18n instance with options
export const i18n = new VueI18n({
    locale: 'en', // set locale
    fallbackLocale: 'en', 
    messages: {
        en: {      
            lngBtnText: 'ພາສາ',
            welcomeText1: 'Welcome to Statable!',
            welcomeText2: 'The access portal to statistical data from the Lao Government.',
            showDataBtnText: 'Show Data',
            saveAsTableBtnText: 'Save As Table',
            saveAsShpBtnText: 'Save As Shapefile',
            saveAsFileGeoBtnText: 'Save As File Geodatabase',
            videoTutorialBtnText: 'Video Tutorial',
            userManualBtnText: 'User Manual',
            dataset: {
                census2005:'Population Census 2005',
                census2015:'Population Census 2015',
                census2011:'Agricultural Census 2011'
            },
            adminLevel: {
                village: 'Village',
                district: 'District',
                kumban: 'Kumban'
            },
            searchVariableText: 'Search Variable',
            searchLocationText: 'Search Location',
            waitMsg: 'Please wait, retrieving data to download',
            navMenu: {
                home: 'Home',
                mapExplorer: 'Map Explorer',
                mapAnalyst: 'Map Analyst',
                oda: 'ODA Context',
                mapRepository: 'Map Repository',
                catalogue: 'Data Catalogue',
                publication: 'Publications',
                help: 'Help'
            }
        },
        lo: {
            lngBtnText: 'Eng',
            welcomeText1: 'ຍິນດີຕ້້ອນຮັບ Statable!',
            welcomeText2: 'ການເຂົ້າເຖິງຖານຂໍ້ມູນທາງສະຖິຕິຈາກລັດຖະບານລາວ.',
            showDataBtnText: 'ສະແດງຂໍ້ມູນ',
            saveAsTableBtnText: 'ອັດບັນທຶກເປັນຕາຕະລາງ',
            saveAsShpBtnText: 'ອັດບັນທຶກເປັນຮູບພາບ (Shapefile)',
            saveAsFileGeoBtnText: 'ບັນທຶກເປັນຈີໂອດາຕາເບດ',
            videoTutorialBtnText: 'ວີດີໂອ ອະທິບາຍຂັ້ນຕອນການນຳໃຊ້',
            userManualBtnText: 'ຄູ່ມືການນຳໃຊ້',
            dataset: {
                census2005:'ການສຳຫຼວດປະຊາກອນ 2005',
                census2015:'ການສຳຫຼວດປະຊາກອນ 2015',
                census2011:'ການສຳຫຼວດການກະສິກຳ 2011'
            },
            adminLevel: {
                village: 'ບ້ານ',
                district: 'ເມືອງ',
                kumban: 'Kumban'
            },
            searchVariableText: 'ຊອກຕົວແປ',
            searchLocationText: 'ຊອກທີ່ຕັ້ງ',
            waitMsg: 'ກະລຸນາລໍຖ້າ, ກຳລັງດືງຂໍ້ມູນເພື່ອດາວໂຫລດ',
            navMenu: {
                home: 'ໜ້າຫຼັກ',
                mapExplorer: 'ເຄື່ອງມືສ້າງແຜນທີ່',
                mapAnalyst: 'ເຄື່ອງມືວິເຄາະຂໍ້ມູນດ້ານແຜນທີ່',
                oda: 'ການຊ່ວຍເຫຼືອເພື່ອການພັດທະນາ',
                mapRepository: 'ດາວໂຫຼດແຜນທີ່ສຳເລັດຮູບ',
                catalogue: 'ຊຸດຂໍ້ມູນ',
                publication: 'ສີ່ງພິມ',
                help: 'ຊ່ວຍເຫຼືອ'
            }
        }
    }
})
  